import { render, staticRenderFns } from "./ValidarNuevoDocumento.vue?vue&type=template&id=4a39b402&"
import script from "./ValidarNuevoDocumento.vue?vue&type=script&lang=js&"
export * from "./ValidarNuevoDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports